import isEmpty from 'lodash/isEmpty'

type Success<T> = { success: true; value: T }
type Failure = { success: false; errorCode: string }

export type Result<T> = Success<T> | Failure

export function assertNever(value: never): never {
  throw new Error(`Unhandled discriminated union member: ${JSON.stringify(value)}`)
}

export function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
  return !isEmpty(value)
}
